"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _base = _interopRequireDefault(require("@emotion/styled/base"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _framerMotion = require("framer-motion");

var _Toast = require("./Toast.styles");

var _icons = require("../../assets/icons");

var ControlBtn = (0, _base["default"])("button", {
  target: "e1vhswz33",
  label: "ControlBtn"
})(_Toast.styles.controlBtn, ";");
var Content = (0, _base["default"])("div", {
  target: "e1vhswz32",
  label: "Content"
})(_Toast.styles.content, ";");
var ProgressBar = (0, _base["default"])("div", {
  target: "e1vhswz31",
  label: "ProgressBar"
})(_Toast.styles.progress, ";");
var Container = (0, _base["default"])("div", {
  target: "e1vhswz30",
  label: "Container"
})(function (_ref) {
  var type = _ref.type,
      theme = _ref.theme;
  return _Toast.styles[type]({
    theme: theme,
    ControlBtn: ControlBtn,
    Content: Content,
    ProgressBar: ProgressBar
  });
}, ";");
var types = {
  warning: {
    icon: (0, _jsxRuntime.jsx)(_icons.Note, {}),
    actionText: 'Dismiss'
  },
  error: {
    icon: (0, _jsxRuntime.jsx)(_icons.Negative, {}),
    actionText: 'Try again'
  },
  positive: {
    icon: (0, _jsxRuntime.jsx)(_icons.Valid, {}),
    actionText: 'Got it!'
  }
};

var Toast = function Toast(_ref2) {
  var className = _ref2.className,
      duration = _ref2.duration,
      onClose = _ref2.onClose,
      noticeKey = _ref2.noticeKey,
      closeable = _ref2.closeable,
      children = _ref2.children,
      type = _ref2.type,
      hideProgress = _ref2.hideProgress,
      actionText = _ref2.actionText,
      onClickAction = _ref2.onClickAction,
      noAction = _ref2.noAction;
  var closeTimer = (0, _react.useRef)(); // Keep tract of duration

  var durationTrack = (0, _react.useRef)({
    startMs: 0,
    remainingMs: 0
  });

  var _useState = (0, _react.useState)(true),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      isRunning = _useState2[0],
      setIsRunning = _useState2[1];

  var showProgess = !hideProgress && duration;
  var finalActionText = (0, _react.useMemo)(function () {
    return actionText || types[type].actionText;
  }, [actionText, type]);
  var clearCloseTimer = (0, _react.useCallback)(function () {
    if (closeTimer.current) {
      clearTimeout(closeTimer.current);
      closeTimer.current = null;
    }
  }, []); // Remove a toast

  var close = (0, _react.useCallback)(function (e) {
    if (e) {
      e.stopPropagation();
    }

    clearCloseTimer();
    onClose(noticeKey);
  }, [clearCloseTimer, noticeKey, onClose]);
  var startCloseTimer = (0, _react.useCallback)(function () {
    // After duration to close the toast
    // Only keep run the remaining duration
    if (duration) {
      durationTrack.current.startMs = new Date().getTime();
      closeTimer.current = setTimeout(function () {
        close();
      }, durationTrack.current.remainingMs);
    }
  }, [close, duration]);
  var restartCloseTimer = (0, _react.useCallback)(function () {
    clearCloseTimer();
    startCloseTimer();
  }, [clearCloseTimer, startCloseTimer]);
  (0, _react.useEffect)(function () {
    return clearCloseTimer;
  }, [clearCloseTimer, startCloseTimer]); // Restart timer and save remainig time if the duration prop is changed

  (0, _react.useEffect)(function () {
    durationTrack.current.remainingMs = duration * 1000;
    restartCloseTimer();
  }, [duration, restartCloseTimer]);
  var handleClickAction = (0, _react.useCallback)(function (e) {
    close();
    onClickAction(e);
  }, [close, onClickAction]); // Pause running duration

  var handlePause = (0, _react.useCallback)(function () {
    // Save the remainng time
    durationTrack.current.remainingMs -= new Date().getTime() - durationTrack.current.startMs;
    setIsRunning(false);
    clearCloseTimer();
  }, [clearCloseTimer]); // Restart running duration

  var handleRun = (0, _react.useCallback)(function () {
    startCloseTimer();
    setIsRunning(true);
  }, [startCloseTimer]);
  return (0, _jsxRuntime.jsxs)(_framerMotion.motion.div, {
    className: className,
    css: _Toast.styles.noticeWrapper,
    onMouseEnter: handlePause,
    onMouseLeave: handleRun,
    layout: true,
    initial: {
      opacity: 0,
      y: 50,
      rotate: -5
    },
    animate: {
      opacity: 1,
      y: 0,
      rotate: 0
    },
    transition: {
      duration: 0.3
    },
    exit: {
      opacity: 0,
      transition: {
        duration: 0.2
      }
    },
    children: [(0, _jsxRuntime.jsxs)(Container, {
      type: type,
      children: [(0, _jsxRuntime.jsxs)(Content, {
        children: [types[type].icon, (0, _jsxRuntime.jsxs)("div", {
          children: [children, (0, _jsxRuntime.jsx)("br", {}), !noAction && (0, _jsxRuntime.jsx)(ControlBtn, {
            type: "button",
            className: "grui",
            noticeType: type,
            onClick: handleClickAction,
            children: finalActionText
          })]
        })]
      }), closeable && (0, _jsxRuntime.jsx)("button", {
        type: "button",
        className: "grui",
        onClick: close,
        css: _Toast.styles.closeBtn,
        children: (0, _jsxRuntime.jsx)(_icons.Close, {})
      })]
    }), showProgess && (0, _jsxRuntime.jsx)(ProgressBar, {
      style: {
        animationDuration: "".concat(duration, "s"),
        animationPlayState: isRunning ? 'running' : 'paused'
      },
      type: type
    })]
  });
};

Toast.propTypes = {
  className: _propTypes.string,

  /**
   * After duration of time, this toast will disappear (seconds)
   * if set to falsy value, will not disappear automatically
   */
  duration: _propTypes.number,

  /**
   * Callback for when the toast is removed
   */
  onClose: _propTypes.func,
  noticeKey: _propTypes.string,

  /**
   * Whether showing close button
   */
  closeable: _propTypes.bool,
  children: _propTypes.node,
  type: (0, _propTypes.oneOf)(Object.keys(types)),

  /**
   * Whether show progress,
   * duration must exists
   */
  hideProgress: _propTypes.bool,

  /**
   * Action button label
   */
  actionText: _propTypes.string,

  /**
   * Callback for handling clicking action button
   */
  onClickAction: _propTypes.func,
  noAction: _propTypes.bool
};
Toast.defaultProps = {
  className: undefined,
  duration: 5,
  onClose: function onClose() {},
  noticeKey: undefined,
  closeable: true,
  children: undefined,
  type: 'warning',
  hideProgress: false,
  actionText: undefined,
  onClickAction: function onClickAction() {},
  noAction: false
};
var _default = Toast;
exports["default"] = _default;
//# sourceMappingURL=Toast.js.map